module.exports = __webpack_public_path__ + "static/media/DSC_0001.e2512a59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0001.jpg
// module id = 674
// module chunks = 0